import React from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import WithLabel, { LABEL_STYLES } from '../../../components/with-label/WithLabel';
import WithError from '../../../components/with-error/WithError';
import CommonSwitch from '../../../components/common-switch/CommonSwitch';

import scss from './SwitchInput.module.scss';

function SwitchInput({ name, label, isRequired, disabled, subLabels }) {
  const { t } = useTranslation('studio');

  return (
    <WithLabel variant={LABEL_STYLES.ROW} label={label} isRequired={isRequired} isBold isTwoDots>
      <Field name={name} type='checkbox'>
        {({ input, meta }) => (
          <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
            <div className={scss.switchWrapper}>
              {subLabels?.false && (
                <span className={clsx(scss.subLabel, !input.checked && scss.checkedSubLabel)}>{subLabels.false}</span>
              )}
              <CommonSwitch name={name} checked={input.checked} onChange={input.onChange} disabled={disabled} />
              {subLabels?.true && (
                <span className={clsx(scss.subLabel, input.checked && scss.checkedSubLabel)}>{subLabels.true}</span>
              )}
            </div>
          </WithError>
        )}
      </Field>
    </WithLabel>
  );
}

export default SwitchInput;
